import { render, staticRenderFns } from "./PaymentConfirmation.vue?vue&type=template&id=d235b0c4&scoped=true&"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=ts&"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentConfirmation.vue?vue&type=style&index=0&id=d235b0c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d235b0c4",
  null
  
)

export default component.exports